import React, { useEffect, useState } from 'react';
import LocalizedText from '../presentational/LocalizedText';
import useTranslate from "../../hooks/useTranslate";
import { isValidEmail } from "./utils";
import { Button, FormGroup, Input, Intent } from '@careevolution/design-system';
interface VerifyNonceProps {
  serverError: string;
  isLoading: boolean;
  emailOrPhone: string;
  verifyPasswordResetNonce: (emailOrPhone: string, verificationCode: string) => void;
  forgotPassword: () => void;
}

const VerifyNonce: React.FC<VerifyNonceProps> = ({
  serverError,
  isLoading,
  emailOrPhone,
  verifyPasswordResetNonce,
  forgotPassword,
}) => {
  const [verificationCode, setVerificationCode] = useState('')
  const translations = useTranslate(["participant-login-verification-code-label", "participant-login-next-label"])

  const handleSubmit = () => {
    verifyPasswordResetNonce(emailOrPhone, verificationCode)
    return false
  }

  useEffect(() => {
    if (window.renderTurnstile) {
      window.renderTurnstile();
    }
  }, []);

  return (
    <form className="login-action" onSubmit={handleSubmit}>
      <h1><LocalizedText textKey="participant-login-verify-nonce-title" /></h1>
      <p><LocalizedText textKey={isValidEmail(emailOrPhone) ? "participant-login-verify-nonce-info" : "participant-login-verify-nonce-info-phone"} values={{ emailOrPhone: emailOrPhone }} /></p>
      {
        serverError && (
          <p className="server-error">{serverError}</p>
        )
      }
      <FormGroup
        className="login-field"
        label={translations["participant-login-verification-code-label"]}
      >
        <Input
          autoComplete="one-time-code"
          className="autofocus"
          disabled={isLoading}
          onChange={(e) => setVerificationCode(e.target.value)}
          id="verificationCode"
          type="tel"
          value={verificationCode}
          placeholder="123-123-1234"
          fullWidth={true}
          htmlAttributes={{
            pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}",
            maxLength: 12,
            spellCheck: "false",
            autoCorrect: "off",
            autoCapitalize: "none",
          }}
        />
      </FormGroup>
      <div className="turnstile-container">
        <div id="cf-turnstile" className="cf-turnstile"></div>
      </div>
      <Button
        onClick={handleSubmit}
        disabled={!verificationCode.length}
        className="primary-action"
        width="100%"
        intent={Intent.primary}
        loading={isLoading}
        type='submit'
      >
        <span dangerouslySetInnerHTML={{ __html: translations["participant-login-next-label"] }} />
      </Button>
      <p className="sub-action">
        <Button
          onClick={forgotPassword}
          variant='minimal'
          width='100%'
        ><LocalizedText textKey="participant-login-forgot-password-label" /></Button></p>
    </form>
  )
}

export default VerifyNonce